__turbopack_context__.v({
  "stackItem": "Stack-module__aZiPJq__stackItem",
});
